<template>
  <section
    id="login"
  >
    <v-row dense no-gutters>
      <v-col
        cols="12"
        lg="7"
        :hidden="$vuetify.breakpoint.mdAndDown"
      >
        <v-card
          width="100%"
          height="100vh"
          color="primary"
          class="d-flex flex-column justify-center align-center"
          tile
          flat
          dark
        >
          <div class="my-5">
            <v-img
              width="120px"
              height="auto"
              :src="require('@/assets/images/logos/logo_circle_white.png')"
            ></v-img>
          </div>
          <div class="text-h1 font-weight-medium">
            Intranet Portal
          </div>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="5"
      >
        <v-card
          width="100%"
          height="100vh"
          color="grey lighten-4"
          class="d-flex flex-column justify-center align-center"
          tile
          flat
        >
          <v-card
            max-width="400px"
            color="transparent"
            flat
            tile
          >
            <v-form ref="form" @submit.prevent="sendPasswordRecoveryLink">
                <v-row v-if="recoveryEmail === null">
                    <v-col cols="12">
                        <div class="text-h5 grey--text font-weight-bold">
                            Forgot Password? <span class="text-h6">🔒</span>
                        </div>
                        <div class="grey--text">
                            Enter your email and we'll send you instructions to reset your password
                        </div>
                    </v-col>
                    <v-col 
                        v-if="message"
                        cols="12"
                    >
                        <v-alert dense outlined type="error" dismissible>
                        {{ message }}
                        </v-alert>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="user.userName"
                        label="Enter your username or email"
                        placeholder=" "
                        required
                        outlined
                        hide-details="auto"
                        :disabled="loading"
                        :rules="[required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-btn 
                        color="primary" 
                        type="submit"
                        :loading="loading"
                        block
                      >
                        Send reset link
                      </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" class="text-center">
                        <div class="success--text">We sent a reset link to you at </div>
                        <div class="text-h6 grey--text">{{ recoveryEmail }}</div>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn
                            class="my-2"
                            text
                            color="primary"
                            block
                            to="/auth/login"
                        >
                            <v-icon>
                                mdi-chevron-left
                            </v-icon>
                            Back to login
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import User from "@/models/user";
import AuthService from '@/services/auth.service';
import { convert, rules } from "@/mixins";

export default {
  name: "ForgetPassword",
  data() {
    return {
      user: new User("", ""),
      loading: false,
      message: null,
      recoveryEmail: null,
    };
  },
  methods: {
    async sendPasswordRecoveryLink() {
      this.loading = true;
      if (this.$refs.form.validate() === true) {
          await AuthService.sendPasswordRecoveryLink(this.user.userName)
          .then(userEmail => {
              this.recoveryEmail = userEmail;
              this.message = null;
          })
          .catch(error => {
              this.message = this.toErrorMessage(error);
              this.recoveryEmail = null;
          })
      }

      this.loading = false;
    }
  },
  mixins: [convert, rules],
};
</script>
